import { Badge } from "@mantine/core";

/**
 * Farbe nach Jira-**Kategorie**, nicht nach Anzeigename: done → grün,
 * indeterminate → gelb, new → grau. Stabil über Sprachen und Workflows.
 */
export function StatusBadge({ status, category }: { status: string; category?: string }) {
  const color = category === "done" ? "green" : category === "indeterminate" ? "yellow" : "gray";
  return (
    <Badge variant="light" color={color} size="sm" radius="sm" style={{ textTransform: "none" }}>
      {status}
    </Badge>
  );
}
